export default {
  setTemplates(state, templates) {
    state.templates = templates;
  },
};
